import BaseBrowserStore from './base/base-browser-store.js'
import {
    captureError,
    clearSentryUser,
    setSentryUser,
} from '../utilities/use-sentry.js'

class UserStore extends BaseBrowserStore {
    constructor (user = {}) {
        super('user')
    }

    async setUser (user) {
        await this.set('user', JSON.stringify(user))
        if (user.email) {
            await this.setEmail(user.email)
        }
        if (user.verified_at) {
            await this.setVerifiedAt(user.verified_at)
        }
        if (user) {
            setSentryUser({
                email: user.email,
                id: user.id,
            })
        }
    }

    // TENANT-5440: read back the cached `GET /user` object stored by
    // `setUser` (JSON string in browser storage). Returns `null` when nothing
    // is cached. A corrupt cache entry is NOT silently treated as "no user"
    // (repo non-negotiable: no silent fallbacks): it is captured to Sentry
    // and purged, then `null` is returned so callers refetch/rebuild it.
    async getUser () {
        const raw = await this.get('user')
        // eslint-disable-next-line unicorn/no-null -- mirrors localStorage's null-for-missing convention
        if (!raw) return null
        try {
            return JSON.parse(raw)
        } catch (error) {
            console.error('UserStore.getUser - corrupt cached user JSON, purging:', error)
            captureError(error)
            await this.remove('user')
            // eslint-disable-next-line unicorn/no-null -- mirrors localStorage's null-for-missing convention
            return null
        }
    }

    async getEmail () {
        return await this.get('email')
    }

    async setEmail (email) {
        await this.set('email', email)
    }

    async getVerifiedAt () {
        return await this.get('verified_at')
    }

    async setVerifiedAt (verified_at) {
        await this.set('verified_at', verified_at)
    }

    async clear () {
        await this.remove('user')
        await this.remove('email')
        await this.remove('verified_at')
        clearSentryUser()
    }
}

const userStore = new UserStore()
export default userStore
